<!--
 * @Description: 字段列表主容器
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->

<template>
  <div :class="['comp-field-main', editable ? 'editable' : 'disabled']" ref="fieldShowRef" @mousedown.stop="handleMousedown" :data-field-type="getRealityFieldType()" :data-field-key="getFieldParams?.fieldKey" :data-field-value="getDataFieldValue()">
    <!-- 使用v-if结合isInViewport实现懒加载 -->

    <template v-if="isInViewport">
      <template v-if="shouldShowContent">
        <component :is="getComponent" :params="{ ...getFieldParams, mask: false }" />
      </template>
      <div v-else class="field-content-empty">
        <template v-if="getFieldParams?.fieldKey == 'qccId'">
          <jw-tag size="small" :color="getFieldParams?.fieldValue ? 'green' : 'pink'">{{ getFieldParams?.fieldValue ? $t('是') : $t('否') }}</jw-tag>
        </template>
        <template v-else>-</template>
      </div>
    </template>
    <template v-else>
      <div class="list-main-skeleton"></div>
    </template>
    <template v-if="isEditShow">
      <!-- 字段编辑容器 -->
      <!-- 多层级 -->
      <template v-if="props.params.tableLevel > 1 || isDetailTable">
        <teleport :to="tableBodyContainer">
          <field-list-content :fields="{ ...getFieldParams, editable: editable }" @cb="updateVal" :clickType="clickType" ref="fieldContentRef" />
        </teleport>
      </template>
      <!-- 一级表格或者分组 -->
      <template v-else>
        <field-list-content :fields="{ ...getFieldParams, editable: editable }" @cb="updateVal" :clickType="clickType" ref="fieldContentRef" />
      </template>
    </template>
  </div>
</template>
<script setup>
import { computed, onBeforeUnmount, ref, inject, provide, onMounted, onUnmounted, nextTick, watch } from 'vue';
import FieldListContent from '../field-list-content/index.vue';
import { tools } from '@/utils/tools';
import useEditFields from '@/hooks/edit-field';
import useShowFields from '@/hooks/field-show';
import { useCellEditManager } from '@/hooks/useCellEditManager';

const { fieldIsEditable, setWarningMessage } = useEditFields();
const { getfieldShowCom } = useShowFields();

const props = defineProps({
  params: {
    type: Object,
    default: () => {}
  }
});

const emits = defineEmits(['callbackList']);
const getMainTableMethods = inject('mainTableMethods'); //调用main-table父组件方法

// 获取tbody的rect对象
const getTableBodyRef =
  getMainTableMethods?.getTableBodyRef ||
  (() => {
    return '';
  });

// 获取表格滚动容器的实例方法
const getScrollContainerRef =
  getMainTableMethods?.getScrollContainerRef ||
  (() => {
    return '';
  });

// 获取展示的容器
const getShowBodyRef =
  getMainTableMethods?.getShowBodyRef ||
  (() => {
    return '';
  });
const fieldShowRef = ref();
const fieldContentRef = ref();
// 懒加载相关状态
const isInViewport = ref(false);
const searchKeywords = inject('defaultParams')?.keywords; // 搜索值
const searchFieldsList = inject('defaultParams')?.searchFieldsList; // 搜索字段
const getFieldParams = computed(() => props.params);
const editable = ref(false);
const contentWidth = ref(100);
const isEditShow = ref(false); //编辑组件状态
const clickType = ref(0); //0:初始状态，1：单机，2：双击

if (getFieldParams.value.fieldType == 1) {
  console.log('表格参数', getFieldParams.value);
}

const getComponent = computed(() => {
  return getfieldShowCom[getFieldParams.value.fieldType] || getfieldShowCom[1];
});
// 判断是否显示内容---为null和undefined、空数组、空对象、空字符串不显示，但等于0或fieldType==24时显示
const shouldShowContent = computed(() => {
  const cvf = props.params.fieldValue;
  if (props.params.fieldType === 24) return true;
  // null和undefined排除
  if (cvf == null) return false;
  if (cvf === 0) return true;
  if (typeof cvf === 'string') return cvf?.length;
  if (Array.isArray(cvf)) return cvf?.length;
  if (typeof cvf === 'object') return Object.keys(cvf)?.length;
  return true;
});

// 更新可编辑的变量
const updateEditable = () => {
  if (editable.value) {
    //能编辑
    editable.value = setWarningMessage(getFieldParams.value, true);
  }
};
// mousedown开关变量
const isMouseDown = ref(false);
const updateIsMouseDown = () => {
  isMouseDown.value = false;
};

const getDataFieldValue = () => {
  return needFieldValueType.includes(getRealityFieldType()) ? getRealityFieldValue() : null;
};
const setEditable = async () => {
  //本行代码不可删除，因为业务规则会实时更新字段权限 2025年08月04日20:11:38 by zl
  editable.value = getFieldParams.value?.isAssTable && getFieldParams.value?.tableLevel > 1 ? false : fieldIsEditable(getFieldParams.value); //是否可编辑框(true:可编辑，false：不可编辑)
  updateEditable();
};
//单机事件(预览)
const handleMousedown = async (e) => {
  handleInit();
  const atr = e.target?.dataset?.link || e.target?.closest('.fh-ellipsis')?.dataset?.link;
  // 主属性字段和关联字段查看详情冒泡到这个地方阻止默认事件
  if (atr && (atr === 'main-field' || atr === 'ass-field')) {
    return;
  }
  if (isEditShow.value && editManager.isActive(getCellClass())) return;
  // 打开编辑状态，这会先关闭其他所有单元格的编辑状态
  editManager.openEdit(getCellClass(), {
    openEdit: async () => {
      await setEditable();
      openPreview();
    },
    closeEdit: () => {
      fieldContentRef.value?.closable();
    }
  });
};
const memoize = (fn) => {
  const cache = new Map();
  return (...args) => {
    const key = JSON.stringify(args);
    if (cache.has(key)) {
      return cache.get(key);
    }
    const result = fn(...args);
    cache.set(key, result);
    return result;
  };
};
// 获取单元格唯一ID(单元格绑定class规则：qf-table-cell-${表格层级}-${数据id}-${字段id})
const getCellClass = memoize(() => {
  return `qf-table-cell-${props.params.tableLevel}-${props.params.row.id}-${props.params.col.id}`;
});

// 使用编辑管理器
const editManager = useCellEditManager();
// 打开预览
const openPreview = async () => {
  if (!fieldShowRef.value) return; //确保dom已经渲染完成
  contentWidth.value = fieldShowRef.value?.clientWidth;
  if (!fieldShowRef.value.classList.contains(getCellClass())) {
    fieldShowRef.value.classList.add(getCellClass()); // 不存在则添加
  }
  clickType.value = 1;
  isEditShow.value = true;
  isMouseDown.value = true;
};

//编辑之后恢复状态
const updateEditStatus = () => {
  // 清理DOM引用
  fieldShowRef.value = null;
  fieldContentRef.value = null;
  clickType.value = 0;
  fieldContentRef.value?.updateClickType(clickType.value);
  isEditShow.value = false;
};
import useTableSearch from '@/hooks/fh-table-search';
import _ from 'lodash';

const { highlightText, clearHighlight } = useTableSearch();

/* 高亮逻辑 start */
const needFieldValueType = [7, 16, 23]; //金额、数字、百分比
const getRealityFieldType = () => {
  const fieldType = getFieldParams.value.fieldType;
  if (fieldType === 24) {
    const colExtra = tools.isJSON(getFieldParams.value.col.fieldExt) ? JSON.parse(getFieldParams.value.col.fieldExt) : {};
    if (colExtra) {
      return colExtra.type;
    }
  }
  return fieldType;
};

const getRealityFieldValue = () => {
  const realityFieldType = getRealityFieldType();
  let fieldValue = getFieldParams.value.fieldValue;
  if (realityFieldType == 16) {
    fieldValue = tools.getPrice(fieldValue, getFieldParams.value.fieldExt);
  }
  if (realityFieldType == 23) {
    fieldValue = tools.getPercentage(fieldValue, getFieldParams.value.fieldExt);
  }
  return fieldValue;
};

/* 高亮逻辑 end */
const handleSearch = _.debounce(async (value) => {
  await nextTick();
  highlightText(value, searchFieldsList.value, fieldShowRef.value);
}, 300);
const tableBodyContainer = ref(null);

const isDetailTable = computed(() => {
  return getFieldParams.value?.isAssTable;
});

const handleInit = () => {
  if (getFieldParams.value.tableLevel === 0) {
    //分组
    tableBodyContainer.value = getTableBodyRef(1) || document?.querySelector('.qf-table-header-body');
  } else {
    //表格
    tableBodyContainer.value = isDetailTable.value ? getShowBodyRef(1) : getTableBodyRef(1); //一级表体
  }
};

const getRootElement = () => {
  return getScrollContainerRef(1) || getShowBodyRef(1) || null;
};

const rootElement = getRootElement();
// 设置懒加载观察器
const intersectionObserver = ref(null);
//  修改setupIntersectionObserver函数
const setupIntersectionObserver = () => {
  if (!fieldShowRef.value || intersectionObserver.value) return;
  intersectionObserver.value = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          isInViewport.value = true;
          if (searchKeywords?.value) {
            handleSearch(searchKeywords.value);
          }
          // 自动取消观察
          intersectionObserver.value?.unobserve(entry.target);
        }
      });
    },
    {
      root: rootElement,
      rootMargin: '300px',
      threshold: 0.01
    }
  );
  intersectionObserver.value.observe(fieldShowRef.value);
};

//  修改清理函数
const cleanupObserver = () => {
  if (intersectionObserver.value) {
    // 先断开所有观察
    intersectionObserver.value.disconnect();
    intersectionObserver.value = null;
  }
};

// 监听searchKeywords的变化
watch(
  () => searchKeywords?.value,
  (newVal, oldVal) => {
    if (isInViewport.value) {
      if (newVal) {
        handleSearch(newVal);
      } else if (oldVal) {
        // 只在关键字从有到无的时候清除高亮
        clearHighlight();
      }
    }
  }
);

onMounted(() => {
  editable.value = getFieldParams.value?.isAssTable && getFieldParams.value?.tableLevel > 1 ? false : fieldIsEditable(getFieldParams.value);

  if (getFieldParams.value?.virtual) {
    // 如果存在虚拟列表
    nextTick(() => {
      // 初始时先检查是否在视口内
      const checkVisibility = () => {
        if (!fieldShowRef.value) return;
        const rect = fieldShowRef.value.getBoundingClientRect();
        const containerRect = rootElement?.getBoundingClientRect();
        if (rect && containerRect && rect.top < containerRect.bottom && rect.bottom > containerRect.top) {
          isInViewport.value = true;
          if (searchKeywords?.value) {
            handleSearch(searchKeywords.value);
          }
        } else {
          setupIntersectionObserver();
        }
      };
      checkVisibility();
    });
  } else {
    // 非虚拟列表 首屏仅加载可视区域内
    const rect = fieldShowRef.value?.getBoundingClientRect();
    if (rect) {
      const viewWidth = window.innerWidth;
      const viewHeight = window.innerHeight;

      // 进入可视区域（完整判断）
      const isVisible = rect.bottom > 0 && rect.top < viewHeight && rect.right > 0 && rect.left < viewWidth;

      if (isVisible) {
        isInViewport.value = true; // 直接加载首屏，不等 observer
        return;
      }
    }
    setupIntersectionObserver(); // 性能优化，初始化不去改变
  }

  nextTick(() => {});
});
onBeforeUnmount(() => {
  // 确保在卸载前清理
  if (fieldShowRef.value && intersectionObserver.value) {
    intersectionObserver.value.unobserve(fieldShowRef.value);
  }
  cleanupObserver();
});
// 增强组件卸载时的清理逻辑
onUnmounted(() => {
  cleanupObserver();
  // 确保组件卸载时关闭编辑状态
  if (editManager?.isActive(getCellClass())) {
    editManager?.closeCurrent();
  }
  // 清理DOM引用
  fieldShowRef.value = null;
  fieldContentRef.value = null;
});
// 公共方法
provide('fieldEditMethods', {
  updateEditStatus: updateEditStatus
});
provide('fieldShowInfo', {
  fieldValue: getDataFieldValue(),
  fieldKey: getFieldParams.value?.fieldKey,
  fieldType: getRealityFieldType()
});

// 公共变量
provide('fieldEditData', {
  contentWidth: computed(() => contentWidth.value),
  parentCellClass: getCellClass(),
  cellRef: computed(() => fieldShowRef.value),
  tableBodyContainer: computed(() => tableBodyContainer.value),
  isMouseDown: computed(() => isMouseDown.value),
  updateIsMouseDown: updateIsMouseDown
});
// 更新编辑之后的值
const updateVal = ({ fieldValue, businessId }) => {
  updateEditStatus();

  // 通过.分割数组并取最后一个，兼容详情子表单快捷编辑
  const _splitFieldKey = getFieldParams.value.fieldKey?.split('.');
  const _fieldKey = _splitFieldKey?.[_splitFieldKey?.length - 1] || getFieldParams.value.fieldKey;
  emits('callbackList', { fieldValue, businessId, fieldKey: _fieldKey });
};
</script>
<style scoped lang="less">
@import './index.less';
</style>
